// Centralized storage keys for shared/storage.
// See react-rewrite-plan.md sections 8.3 and 11.2 platform-storage.
//
// Auth-token keys deliberately do NOT live here. They belong to the future
// `shared/auth` slice so token access stays funneled through one module.

export const STORAGE_KEYS = {
  sidebarCollapsed: 'agenthub:sidebar-collapsed',
  chatSession: 'agenthub:chat-session',
  chatWorkspace: 'agenthub:chat-workspace',
  chatView: 'agenthub:chat-view',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
